const $ = require('jquery')

function shareSocial () {
    function cutoffTitle(title) {
        title = title.toString();
        if (title.indexOf('|') > 0) { title = title.substr(0, title.lastIndexOf('|') - 1); }
        if (title.indexOf('|') > 0) { title = title.substr(0, title.lastIndexOf('|') - 1); }
        return title;
    }
    $('.sendclipboard').click(function (e) {
        e.preventDefault();
        var dummy = document.createElement('input'),
            text = currentUrl;//$(this).attr('data-href');
        //if (!text) text = window.location.href;

        document.body.appendChild(dummy);
        dummy.value = text;
        dummy.select();
        document.execCommand('copy');
        dummy.value = '';
        dummy.select();
        document.execCommand('paste');
        var ret = dummy.value;
        if (ret == text) {
            alert('Hãy dùng Ctrl+V hoặc paste để dán nội dung vừa copy!');
        } else {
            window.prompt('Trình duyệt của bạn không hỗ trợ thao tác này. Bạn có thể copy nội dung ở đây:', text);
        }
        document.body.removeChild(dummy);
    });
    $('.sendsocial').click(function (e) {
        e.preventDefault();
        var url = '';
        var href = $(this).attr('data-href');
        if (!href)
            href = window.location.href;
        switch ($(this).attr('rel')) {
            case "facebook":
                url = "https://www.facebook.com/sharer.php?u=" + href + "&p[title]=" + cutoffTitle(document.title);
                break;
            case "twitter":
                url = "https://twitter.com/share?url=" + href + "&title=" + cutoffTitle(document.title);
                break;
            case "gplus":
                url = "https://plus.google.com/share?url=" + href;
                break;
        }
        if (url == '') return false;
        var newWindow = window.open(url, '', '_blank,resizable=yes,width=800,height=450');
        newWindow.focus();
        return false;
    });
}

export default $(document).ready(function (){
    shareSocial()
})
